import React from "react";
import ReactDOM from "react-dom/client";

import { ThemeProvider } from "@emotion/react";

import { theme } from "./theme";

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);
